import React from 'react';
import {Translate} from "../../../../../lang/lang";
import {useSelector} from "react-redux";
import {selectLang} from "../../../../../store/reducers/main/main";
import {Controller, useFieldArray, useFormContext, useWatch} from "react-hook-form";
import {FloatingLabel, Form} from "react-bootstrap";
import {ErrorMessage} from "@hookform/error-message";


const NameRow = ({itemFieldName, itemIndex, onRightClickHandler, checkIsExistingItem, id}) => {

    const t = Translate;
    const lang = useSelector(selectLang);
    const form = useFormContext();
    const {fields} = useFieldArray({name: `${itemFieldName}.names`});
    const names = useWatch({name: `${itemFieldName}.names`});
    const itemName = names.map(obj => obj.name.trim()).join(' ').trim();
    const isExistingName = checkIsExistingItem(itemName, null, null, id);

    return fields.map((field, index) => {
        return (
            <td key={field.id} className={'py-0 align-middle'}>
                <Controller name={`${itemFieldName}.names.${index}.name`}
                            rules={{
                                required: {
                                    value: index === 0,
                                    message: t(lang, 'items.common.validations.is_required')
                                }
                            }}
                            render={({field}) => {
                                const {error} = form.getFieldState(`${itemFieldName}.names.${index}`, form.formState);
                                return (
                                    <Form.Group>
                                        <FloatingLabel label={t(lang, "items.common.name")}>
                                            <Form.Control name={`${itemFieldName}.names.${index}.name`}
                                                          placeholder={t(lang, 'items.common.name')}
                                                          style={{minWidth: '300px'}}
                                                          isInvalid={error?.name || isExistingName}
                                                          ref={field.ref}
                                                          defaultValue={field.value}
                                                          onChange={field.onChange}
                                                          onContextMenu={(e) => onRightClickHandler(e, itemIndex, `names.${index}.name`, field.value)}
                                            />
                                        </FloatingLabel>

                                        <ErrorMessage name={'name'}
                                                      errors={error}
                                                      as={<Form.Control.Feedback type="invalid"/>}
                                        />
                                        {isExistingName && <div className="text-danger fs--1">{t(lang, "items.common.validations.name_exists", {name: itemName})}</div>}
                                    </Form.Group>
                                )
                            }}
                />
            </td>
        )
    })
};

export default NameRow;
